// --------------------------------------------------------------
// Created On: 2025-04-24
// Author: Zachary Thomas
//
// Last Modified: 2025-04-25
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Get all series organized by the units they are using and make sure only one series is assigned the task of drawing
// the y-axis for a given unit. The object generated by this function allows easy look up to see if a specific series
// is responsible for drawing a shared y-axis.
export default function getSeriesUnitMap(series: AccumulationDataSeries[] | TimeDataSeries[]): SeriesUnitMap {
  const seriesUnitMap: SeriesUnitMap = {};

  series.forEach((singleSeries, i) => {
    let thisSeriesDrawsAxis = false;
    // Check if the unit name is already in the map, otherwise add it.
    if (!(singleSeries.unitName in seriesUnitMap)) {
      seriesUnitMap[singleSeries.unitName] = {};
      thisSeriesDrawsAxis = true;
    }
    // Check if the series index is already in the map, otherwise add it.
    if (!(i in seriesUnitMap[singleSeries.unitName])) {
      seriesUnitMap[singleSeries.unitName][i] = { thisSeriesDrawsAxis: thisSeriesDrawsAxis };
    }
  });

  return seriesUnitMap;
}

interface SeriesUnitMap {
  [key: string]: {
    // The dynamic key is the unit name.
    [key: string]: {
      // The dynamic key is the series index number.
      thisSeriesDrawsAxis: boolean; // Whether this specific series is generating the y-axis.
    };
  };
}

interface TimeDataSeries {
  name: string;
  unitName: string;
  unitShortName: string;
  data: [number, number][];
}

interface AccumulationDataSeries {
  name: string;
  unitName: string;
  unitShortName: string;
  data: number[];
}
